import React, { useState, useEffect } from 'react';
import { Layout } from '../components/page-layout';
import styled from 'styled-components';
import desktopBg from '../assets/web/artboard-desktop.png';
import mobileBg from '../assets/mobile/column.png';
import aiDetectVideo from '../assets/ai-detect.mp4';
import otherAnimalsVideo from '../assets/other-animals.mp4';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Dollar from '../assets/Dollar.png';
import Handshake from '../assets/Handshake.png';
import Smiley from '../assets/Smiley.png';
import artboard1 from '../assets/Artboard-1.png';

// Desktop Images
import desktopImage250 from '../assets/web/250.png';
import desktopImage251 from '../assets/web/251.png';
import desktopImage303 from '../assets/web/303.png';
import desktopImage252 from '../assets/web/252.png';
import desktopImage253 from '../assets/web/253.png';

// Mobile Images
import mobileImage20 from '../assets/mobile/20.png';
import mobileImage21 from '../assets/mobile/21.png';
import mobileImage251 from '../assets/mobile/251.png';
import mobileImageGift from '../assets/mobile/gift.png';
import mobileImage23 from '../assets/mobile/23.png';
import CustomerSay from '../components/bird-customerSay';

const HeroSection = styled.section`
  width: 100%;
  aspect-ratio: 16/9;
  min-height: 400px;
  background: url(${artboard1}) no-repeat center top;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  @media (max-width: 900px) {
    width: 100vw;
    aspect-ratio: unset;
    min-height: unset;
    background: none;
    display: block;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }
`;

const HeroContent = styled.div`
  position: absolute;
  left: 4rem;
  bottom: 3rem;
  z-index: 2;
  background: transparent;
  box-shadow: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  width: auto;
  @media (max-width: 900px) {
    display: none;
  }
`;

const HeroTitle = styled.h1`
  font-size: 3rem;
  font-weight: 800;
  color: #5B2A13;
  margin-bottom: 1.5rem;
  line-height: 1.1;
  @media (max-width: 900px) {
    font-size: 2rem;
  }
`;

const HeroDesc = styled.p`
  font-size: 1.25rem;
  color: #3A2A1A;
  margin-bottom: 2.5rem;
  line-height: 1.5;
  @media (max-width: 900px) {
    font-size: 1rem;
    margin-bottom: 1.5rem;
  }
`;

const AmazonButton = styled.a`
  display: inline-block;
  background: #F87B15;
  color: #fff;
  font-weight: 700;
  font-size: 1.5rem;
  padding: 0.9rem 2.2rem;
  margin-bottom: 10rem;
  border-radius: 2rem;
  text-decoration: none;
  box-shadow: 0 2px 8px rgba(248,123,21,0.12);
  transition: background 0.2s;
  &:hover {
    background: #d65c00;
  }
  @media (max-width: 900px) {
    margin-bottom: 2.5rem;
  }
`;

const HeroCardMobile = styled.div`
  display: none;
  @media (max-width: 900px) {
    display: block;
    background: #fff;
    border-radius: 12px 12px 0 0;
    margin: 0;
    padding: 2rem 1rem 1.5rem 1rem;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
    text-align: center;
    width: 100%;
    box-sizing: border-box;
  }
`;

const HeroImageMobile = styled.img`
  display: none;
  @media (max-width: 900px) {
    display: block;
    width: 100%;
    height: auto;
    border-radius: 0 0 12px 12px;
    margin: 0;
    object-fit: cover;
    box-sizing: border-box;
  }
`;

const HeroTextOverlay = styled.div`
  position: absolute;
  left: 4rem;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  background: transparent;
  box-shadow: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  max-width: 600px;
  @media (max-width: 900px) {
    position: static;
    transform: none;
    left: 0;
    top: 0;
    max-width: 100%;
    padding: 2rem 1rem 1.5rem 1rem;
    align-items: center;
    text-align: center;
  }
`;

const HeroDescLarge = styled.p`
  font-size: 1.3rem;
  color: #222;
  margin-bottom: 2.5rem;
  line-height: 1.5;
  @media (max-width: 900px) {
    font-size: 1rem;
    margin-bottom: 1.5rem;
  }
`;

const FeatureSection = styled.section<{ whiteBg?: boolean }>`
  width: 100%;
  background: ${(props) => (props.whiteBg ? '#fff' : '#fcf7f4')};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 6rem 0 6rem 0;
  gap: 3rem;
  @media (max-width: 900px) {
    display: none;
  }
`;

const FeatureCardMobile = styled.div`
  display: none;
  @media (max-width: 900px) {
    display: block;
    background: #fff;
    border-radius: 20px;
    margin: 1.5rem 0;
    padding: 2rem 1.2rem 1.5rem 1.2rem;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  }
`;

const FeatureVideoMobile = styled.video`
  display: none;
  @media (max-width: 900px) {
    display: block;
    width: 100%;
    border-radius: 20px;
    margin-top: 1.5rem;
    background: #000;
  }
`;

const VideoWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 900px) {
    width: 100%;
  }
`;

const StyledVideo = styled.video`
  width: 100%;
  max-width: 580px;
  border-radius: 2rem;
  background: #000;
  @media (max-width: 900px) {
    max-width: 100%;
    border-radius: 1.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    box-sizing: border-box;
  }
`;

const FeatureText = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  @media (max-width: 900px) {
    align-items: center;
    text-align: center;
    width: 100%;
  }
`;

const PaddedFeatureText = styled(FeatureText)`
  @media (min-width: 901px) {
    margin-left: 4rem;
  }
`;

const FeatureTitle = styled.h2`
  font-family: 'Nunito', sans-serif;
  color: #5B2A13;
  font-size: 2.2rem;
  font-weight: 900;
  margin-bottom: 1.2rem;
`;

const FeatureDesc = styled.p`
  color: #3A2A1A;
  font-size: 1.1rem;
  margin-bottom: 2rem;
`;

const FeatureHighlight = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.25rem;
  font-weight: 700;
  color: #5B2A13;
  margin-top: 1rem;
`;

const CheckIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  background: #5B2A13;
  color: #fff !important;
  border-radius: 50%;
  font-size: 1.2rem;
`;

const OverlayTitle = styled.h2<{ align?: 'left' | 'center' }>`
  position: absolute;
  top: 4rem;
  left: 0;
  right: 0;
  text-align: ${props => props.align || 'center'};
  color: #5B2A13;
  font-size: 2.2rem;
  font-weight: 800;
  z-index: 1;
  padding-left: ${props => props.align === 'left' ? '8rem' : '0'};

  @media (max-width: 900px) {
    top: 2rem;
    font-size: 2rem;
    padding-left: ${props => props.align === 'left' ? '2rem' : '0'};
  }
`;

const SlideWrapper = styled.div`
  position: relative;
`;

const CarouselSection = styled.section`
  padding: 4rem 0;
  background: #fff;
  .slick-slider {
    position: relative;
    .slick-prev,
    .slick-next {
      z-index: 10;
      width: 40px;
      height: 40px;
      top: 50%;
      transform: translateY(-50%);
    }

    .slick-prev {
      left: 3rem;
    }
    .slick-next {
      right: 3rem;
    }

    .slick-prev:before,
    .slick-next:before {
      font-size: 40px;
      color: #5B2A13;
    }
    
    @media (max-width: 900px) {
        .slick-prev {
            left: 1rem;
        }
        .slick-next {
            right: 1rem;
        }
    }
    .slick-dots {
      position: absolute;
      bottom: 2rem;
      width: 100%;
      z-index: 2;
      li button:before {
        font-size: 12px;
        color: #F87B15;
      }
      li.slick-active button:before {
        color: #F87B15;
      }
    }
  }
`;

const GiftCarouselSection = styled(CarouselSection)`
  background:#fff;
  padding: 0;
`;

const CarouselImage = styled.img`
  width: 100%;
  @media (max-width: 900px) {
    max-width: 350px;
    height: auto;
    display: block;
    margin: 0 auto;
  }
`;

const GiftTextContainer = styled.div`
  position: absolute;
  top: 45%;
  left: 8rem;
  transform: translateY(-50%);
  max-width: 450px;
  z-index: 2;

  @media (max-width: 1200px) {
    left: 4rem;
    max-width: 400px;
  }
  @media (max-width: 900px) {
    position: relative;
    transform: none;
    max-width: 100%;
    padding: 2rem;
    text-align: left;
    left: 0;
    top: 0;
  }
`;

const GiftTitle = styled.h2`
  font-size: 2.8rem;
  font-weight: 800;
  color: #5B2A13;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  @media (max-width: 900px) {
    font-size: 2rem;
  }
`;

const GiftDescription = styled.p`
  font-size: 1.1rem;
  color: #3A2A1A;
  margin-bottom: 2rem;
  line-height: 1.5;
`;

const OrangeLine = styled.div`
  width: 250px;
  height: 3px;
  background: linear-gradient(to right, #F87B15 70%, #fde6d2 100%);
  @media (max-width: 900px) {
    margin-left: 0;
    width: 200px;
  }
`;

const FaqSectionContainer = styled.section`
  padding: 6rem 2rem;
  background: #fff;
  text-align: center;
`;

const FaqTitle = styled.h2`
  font-size: 2.5rem;
  color: #5B2A13;
  font-weight: 800;
  margin-bottom: 1rem;
`;

const FaqSubtitle = styled.p`
  font-size: 1.1rem;
  color: #3A2A1A;
  margin-bottom: 2rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`;

const AccordionWrapper = styled.div`
  max-width: 800px;
  margin: 0 auto;
  text-align: left;
`;

const AccordionItem = styled.div`
  border-bottom: 1px solid #ddd;
`;

const AccordionQuestion = styled.div`
  padding: 1.5rem 1rem;
  font-size: 1.2rem;
  font-weight: 700;
  color: #3A2A1A;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AccordionAnswer = styled.div<{ isOpen: boolean }>`
  padding: 0 1rem 1.5rem;
  font-size: 1rem;
  color: #3A2A1A;
  line-height: 1.6;
  max-height: ${props => (props.isOpen ? '1000px' : '0')};
  overflow: hidden;
  transition: max-height 0.5s ease-in-out, padding 0.5s ease;
  padding-top: ${props => (props.isOpen ? '1rem' : '0')};
  padding-bottom: ${props => (props.isOpen ? '1.5rem' : '0')};
`;

const MoreQuestionsWrapper = styled.div`
  margin-top: 6rem;
`;

const ContactButton = styled.a`
  display: inline-block;
  background: #F87B15;
  color: #000;
  font-weight: 700;
  font-size: 1.1rem;
  padding: 0.9rem 2.2rem;
  border-radius: 2rem;
  text-decoration: none;
  box-shadow: 0 2px 8px rgba(248,123,21,0.12);
  transition: background 0.2s;
  &:hover {
    background: #d65c00;
  }
`;

const faqData = [
    {
      question: 'Does the camera work at night?',
      answer: 'Yes, the camera includes infrared night vision, allowing you to observe birds and wildlife even after dark.',
    },
    {
      question: 'How is the feeder powered?',
      answer: 'The camera includes a removable rechargeable battery which can be powered by the included solar panel or with a USB-C cord.',
    },
    {
        question: 'How is the footage stored?',
        answer: 'We included an sd card that will record videos on the sd card. We also have premium cloud storage that stores events, we provide cloud storage 6 months free for each new user.'
    },
    {
        question: 'How is the bird feeder designed?',
        answer: 'The bird feeder is crafted from natural oak wood and coated with durable oil paint to resist outdoor elements. It blends naturally into the environment, attracting more birds.'
    },
    {
        question: 'Can I install it easily?',
        answer: "Yes! We provide a flexible mounting system including a mounting panel, velcro straps, and a pole mount suitable for fences, trees, walls, poles, and decks."
    },
    {
        question: 'How to prevent squirrels from stealing bird food?',
        answer: "1. Remove Climbing Paths: Install the feeder on a pole with a squirrel baffle, away from any structures. <br/>2. Cover the Food Tray: Use a hardware cloth cover that birds can access but squirrels can't easily breach. <br/>3. Use Automated Deterrents: Activate the siren feature to scare off squirrels and other animals. Be aware that some animals can get used to this sound over time."
    },
    {
        question: 'What AI features are included?',
        answer: 'AI Sensforge software can detect birds and identify bird species. Optional settings allow human and other animal detections if you are interested in monitoring other activities around the feeder.'
    },
    {
        question: 'Do I need a subscription?',
        answer: 'No-monthly subscription is required for core features. Premium features like advanced AI detection and food level detection come with a 6-month free trial for new users.'
    },
    {
        question: 'Can I decorate the bird feeder?',
        answer: 'Yes! Each unit comes with a craft wood banner, allowing you to paint and personalize your bird feeder to make it uniquely yours.'
    },
    {
        question: 'What is the warranty and return policy?',
        answer: 'We follow the return policy of the platform you purchase from (such as Amazon, Shopify etc.). Additionally, we provide a factory 1-year warranty for the camera part.'
    }
  ];

const FaqSection: React.FC = () => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    const toggleAccordion = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <FaqSectionContainer>
            <FaqTitle>Frequently Asked Questions</FaqTitle>
            <FaqSubtitle>If you're still wondering how the Sensforge Smart Bird Feeder works, these FAQs might help.</FaqSubtitle>
            <AccordionWrapper>
                {faqData.map((faq, index) => (
                    <AccordionItem key={index}>
                        <AccordionQuestion onClick={() => toggleAccordion(index)}>
                            {faq.question}
                            <span>{openIndex === index ? '▲' : '▼'}</span>
                        </AccordionQuestion>
                        <AccordionAnswer isOpen={openIndex === index} dangerouslySetInnerHTML={{ __html: faq.answer }} />
                    </AccordionItem>
                ))}
            </AccordionWrapper>
            <MoreQuestionsWrapper>
                <FaqTitle>Have more questions?</FaqTitle>
                <FaqSubtitle>Our team is here to help. Reach out anytime for support.</FaqSubtitle>
                <ContactButton href="/contact-us">Contact Us</ContactButton>
            </MoreQuestionsWrapper>
        </FaqSectionContainer>
    )
}

const PerksBar = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
  border-top: 1px solid #e5e7eb;
  padding: 2rem;
  box-sizing: border-box;
  background: #fff;
`;

const Perk = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`;

const PerkIcon = styled.img`
  width: 1.5rem;
  height: 1.5rem;
`;

const PerkText = styled.span`
  color: #374151;
  font-size: 1rem;
`;

const SmartBirdFeeder: React.FC = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 900);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const slides = [
    {
      title: "What's in the Box?",
      desktopImg: desktopImage250,
      mobileImg: mobileImage21,
    },
    {
      title: 'Easy Setup',
      desktopImg: desktopImage303,
      mobileImg: mobileImage20,
    },
    {
      desktopImg: desktopImage251,
      mobileImg: mobileImage251,
    }
  ];

  const giftSlides = [
    {
      desktopImg: desktopImage252,
      mobileImg: mobileImageGift,
      content: {
          title: 'A Gift to Bring You Together',
          description: 'For bird enthusiasts, grandparents and kids to educate them about birds',
      }
    },
    {
      desktopImg: desktopImage253,
      mobileImg: mobileImage23,
    }
  ];

  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    arrows: true
  };

  const giftCarouselSettings = {
    ...carouselSettings,
    dots: true,
    arrows: true,
  };

  return (
    <Layout showCommonFooter>
      <HeroSection>
        <HeroTextOverlay>
          <HeroTitle>Smart Bird Feeder with AI-Powered Camera</HeroTitle>
          <HeroDescLarge>
            Blends smart AI technology with premium outdoor design. Featuring a solar-powered, rechargeable camera integrated into a natural oak wood bird feeder. Offering real-time bird watching, species identification, and smart animal alerts.
          </HeroDescLarge>
          <AmazonButton href="https://www.amazon.com/dp/B0F84HNS3V" target="_blank" rel="noopener noreferrer">Buy Now</AmazonButton>
        </HeroTextOverlay>
        <HeroImageMobile src={mobileBg} alt="Smart Bird Feeder" />
      </HeroSection>
      <FeatureSection>
        <VideoWrapper>
          <StyledVideo controls poster="">
            <source src={aiDetectVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </StyledVideo>
        </VideoWrapper>
        <FeatureText>
          <FeatureTitle><strong>AI-Powered Bird<br />Species Detection</strong></FeatureTitle>
          <FeatureDesc>
            What makes us smart? Our AI-powered technology tells you what species stopped by.
          </FeatureDesc>
          <FeatureHighlight>
            <CheckIcon>✔</CheckIcon>
            6 Months Free
          </FeatureHighlight>
        </FeatureText>
      </FeatureSection>
      <FeatureCardMobile>
        <FeatureTitle><strong>AI-Powered Bird<br />Species Detection</strong></FeatureTitle>
        <FeatureDesc>
          What makes us smart? Our AI-powered technology tells you what species stopped by.
        </FeatureDesc>
        <FeatureHighlight>
          <CheckIcon>✔</CheckIcon>
          6 Months Free
        </FeatureHighlight>
        <FeatureVideoMobile controls poster="">
          <source src={aiDetectVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </FeatureVideoMobile>
      </FeatureCardMobile>
      <FeatureSection whiteBg>
        <PaddedFeatureText>
          <FeatureTitle><strong>Keep Other Animals<br />Away</strong></FeatureTitle>
          <FeatureDesc>
            Get notified when squirrels and other animals approach to keep your bird friends safe.
          </FeatureDesc>
        </PaddedFeatureText>
        <VideoWrapper>
          <StyledVideo controls poster="">
            <source src={otherAnimalsVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </StyledVideo>
        </VideoWrapper>
      </FeatureSection>
      <FeatureCardMobile>
        <FeatureTitle><strong>Keep Other Animals<br />Away</strong></FeatureTitle>
        <FeatureDesc>
          Get notified when squirrels and other animals approach to keep your bird friends safe.
        </FeatureDesc>
        <FeatureVideoMobile controls poster="">
          <source src={otherAnimalsVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </FeatureVideoMobile>
      </FeatureCardMobile>
      <CarouselSection>
        <Slider {...carouselSettings}>
          {slides.map((slide, index) => (
            <SlideWrapper key={index}>
              {slide.title && (
                <OverlayTitle align={slide.title === "What's in the Box?" ? 'left' : 'center'}>
                  {slide.title}
                </OverlayTitle>
              )}
              <CarouselImage src={isMobile ? slide.mobileImg : slide.desktopImg} />
            </SlideWrapper>
          ))}
        </Slider>
      </CarouselSection>
      <GiftCarouselSection>
        <Slider {...giftCarouselSettings}>
          {giftSlides.map((slide, index) => (
            <SlideWrapper key={index}>
              <CarouselImage src={isMobile ? slide.mobileImg : slide.desktopImg} />
            </SlideWrapper>
          ))}
        </Slider>
      </GiftCarouselSection>
      <FaqSection />
      <CustomerSay />
      <PerksBar>
        <Perk>
          <PerkIcon src={Smiley} alt="Icon 1" />
          <PerkText>2-Year Warranty</PerkText>
        </Perk>
        <Perk>
          <PerkIcon src={Dollar} alt="Icon 2" />
          <PerkText>30-Day Money-Back Guarantee</PerkText>
        </Perk>
        <Perk>
          <PerkIcon src={Handshake} alt="Icon 3" />
          <PerkText>Lifetime Customer Support</PerkText>
        </Perk>
      </PerksBar>
    </Layout>
  );
}

export default SmartBirdFeeder;